import styled from 'styled-components';

export default styled.div`
  margin: 6px;
  display: flex;
  justify-content: space-around;
  margin-right: 18px;
`;
